export enum Currency {
  CHF = 'CHF',
  EUR = 'EUR',
}